<template>
	<div class="d-flex justify-start align-center">
		<input type="file" ref="fileInput" :accept="accept" style="display: none" @change="handleFileChange" />

		<slot v-bind="{ trigger }">
			<v-btn color="primary" @click="trigger">选择图片</v-btn>
		</slot>

		<v-dialog v-model="dialog" max-width="800px">
			<v-card>
				<v-card-title>图片预览</v-card-title>
				<v-card-subtitle>
					<v-btn @click="rotateLeft">逆时针旋转</v-btn>
					<v-btn @click="rotateRight">顺时针旋转</v-btn>
					<v-btn @click="zoomIn">放大</v-btn>
					<v-btn @click="zoomOut">缩小</v-btn>
					<v-btn @click="flipX" ref="flipX">水平翻转</v-btn>
					<v-btn @click="flipY" ref="flipY">垂直翻转</v-btn>
					<v-btn @click="crop">裁切</v-btn>
				</v-card-subtitle>
				<v-card-text>
					<vue-cropper
						ref="cropper"
						:src="imageUrl"
						:aspect-ratio="null"
						style="height: 400px; width: 100%"
					/>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="confirm">确定</v-btn>
					<v-btn color="secondary" @click="dialog = false">取消</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import 'cropperjs/dist/cropper.css'
import VueCropper from 'vue-cropperjs'

export default {
	components: {
		VueCropper
	},
	props: {
		// multiple: { type: Boolean, default: false }, 不支持多选
		showCropper: { type: Boolean, default: false },
		accept: { type: String, default: 'image/*' }
	},
	emits: ['chosen'], //有可能返回blob或者File对象
	data() {
		return {
			dialog: false,
			imageUrl: '',
			selectedFile: null,
			upconfig: {},
			files: [],
			progress: 0,
			tries: {}, //filename:times
			retryLimit: 2,
			total: 0,
			scaleX: 1,
			scaleY: 1
		}
	},
	mounted() {},
	methods: {
		handleFileChange(event) {
			console.log('handlefilechange', event.target.files[0])
			//试着支持多张图片

			let files = event.target.files
			// if (file.type.indexOf('image/') === -1) {
			// 	alert('请选择图片')
			// 	return
			// }
			if (this.showCropper) {
				//只能支持单张
				const file = event.target.files[0]
				if (typeof FileReader === 'function') {
					const reader = new FileReader()
					reader.onload = (event) => {
						// console.log('reader.onload', event.target.result)
						this.imageUrl = event.target.result
						// rebuild cropperjs with the updated source
						this.$refs.cropper.replace(event.target.result)
					}
					reader.readAsDataURL(file)
					this.dialog = true
					this.selectedFile = file
				} else {
					alert('Sorry, FileReader API not supported')
				}
			} else {
				let filename = files[0].name
				this.$emit('chosen', { file: files[0], name: filename })
				this.reset()
			}
		},
		rotateLeft() {
			this.$refs.cropper.rotate(-90)
		},
		rotateRight() {
			this.$refs.cropper.rotate(90)
		},
		zoomIn() {
			this.$refs.cropper.relativeZoom(0.1)
		},
		zoomOut() {
			this.$refs.cropper.relativeZoom(-0.1)
		},
		crop() {
			this.imageUrl = this.$refs.cropper.getCroppedCanvas().toDataURL()
			console.log(this.imageUrl)
			this.$refs.cropper.replace(this.imageUrl)
		},
		flipX() {
			this.scaleX = -1 * this.scaleX
			this.$refs.cropper.scaleX(this.scaleX)
		},
		flipY() {
			this.scaleY = -1 * this.scaleY
			this.$refs.cropper.scaleY(this.scaleY)
		},
		reset() {
			this.$refs.fileInput.value = null
		},
		confirm() {
			this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
				this.$emit('chosen', { blob, name: this.selectedFile.name })
				this.dialog = false
				this.reset()
			})
		},
		trigger(event) {
			this.$refs.fileInput.click()
		},

		validateFileSize(files, each = 2) {
			const maxSize = each * 1024 * 1024 // 2MB
			for (let i = 0; i < files.length; i++) {
				if (files[i].size > maxSize) {
					return false
				}
			}
			return true
		},
		resizeImage(file, maxSize) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = (e) => {
					const img = new Image()
					img.onload = () => {
						let canvas = document.createElement('canvas')
						let ctx = canvas.getContext('2d')
						let width = img.width
						let height = img.height
						let resizeRatio = 1

						// Adjust resizeRatio to reduce file size under maxSize
						while (file.size > maxSize && resizeRatio > 0.1) {
							resizeRatio -= 0.1
							width = img.width * resizeRatio
							height = img.height * resizeRatio
							canvas.width = width
							canvas.height = height
							ctx.clearRect(0, 0, width, height)
							ctx.drawImage(img, 0, 0, width, height)

							canvas.toBlob(
								(blob) => {
									if (!blob) return
									console.log('compressed', blob, maxSize)
									if (blob.size <= maxSize) {
										resolve(blob)
									}
								},
								file.type,
								0.7
							) // Adjust quality to further control size
						}
					}
					img.src = e.target.result
				}
				reader.onerror = (error) => reject(error)
				reader.readAsDataURL(file)
			})
		}
	}
}
</script>

<style scoped>
/* Add any additional styles here */
</style>
